import { useEffect, useState } from "react";
import api from "./api";

export function usePromoPreview(foodCart, channel, enabled = true) {
  const [data, setData] = useState(null);
  const cartKey = JSON.stringify(foodCart.map((i) => [i.product_id, i.quantity]));

  useEffect(() => {
    if (!enabled || !foodCart.length) { setData(null); return; }
    const t = setTimeout(() => {
      api.post("/promos/preview", {
        items: foodCart.map((i) => ({
          product_id: i.product_id, quantity: i.quantity,
          spice: i.options?.spice || null, weight: i.options?.weight || null,
          size: i.options?.size || null, persons: i.options?.persons || null,
          component_spices: i.options?.component_spices || null,
        })),
        channel,
      }).then(({ data }) => setData(data)).catch(() => setData(null));
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, channel, cartKey]);

  return data;
}

const DEAL_TYPES = ["percent", "fixed", "bogo_free", "bogo_half", "buy_x_get_y", "bundle"];

export const dealLabel = (p) => {
  const base = p.type === "bogo_free" ? "BUY 1 GET 1 FREE"
    : p.type === "bogo_half" ? "2ND ONE 50% OFF"
    : p.type === "buy_x_get_y" ? `BUY ${p.buy_qty || 1} GET ${p.get_qty || 1} ${Math.round(p.get_discount_pct ?? 100) >= 100 ? "FREE" : `${Math.round(p.get_discount_pct)}% OFF`}`
    : p.type === "bundle" ? (p.bundle_price != null ? `BUNDLE $${Number(p.bundle_price).toFixed(2)}` : "BUNDLE DEAL")
    : p.type === "fixed" ? `$${Math.round(p.value)} OFF${p.min_order ? ` $${Math.round(p.min_order)}+` : ""}`
    : p.type === "free_service" ? `FREE ${(p.service_label || "SERVICE").toUpperCase()}`
    : p.type === "spend_get_item" ? "SPEND & GET FREE ITEM"
    : p.type === "free_delivery" ? "FREE DELIVERY"
    : `${Math.round(p.value)}% OFF`;
  if (p.occasion) return `${p.occasion.toUpperCase()} · ${base}`;
  if (p.is_flash) return `FLASH · ${base}`;
  return base;
};

export function useProductDeals(businessId) {
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    if (!businessId) { setPromos([]); return; }
    api.get("/promos/active", { params: { business_id: businessId } })
      .then(({ data }) => setPromos(data)).catch(() => setPromos([]));
  }, [businessId]);

  return (product, channel) => {
    for (const p of promos) {
      if (!DEAL_TYPES.includes(p.type) || p.members_only) continue;
      if (p.starts_at && new Date(p.starts_at) > new Date()) continue;
      const s = p.scope || {};
      const prodIds = [...(s.product_ids || []), ...(s.product_id ? [s.product_id] : [])];
      const catIds = [...(s.category_ids || []), ...(s.category_id ? [s.category_id] : [])];
      const scopedMatch = prodIds.includes(product.id) || (catIds.length > 0 && catIds.includes(product.category_id));
      const wideMatch = !prodIds.length && !catIds.length && (p.occasion || p.is_flash);
      if (!scopedMatch && !wideMatch) continue;
      if (p.channels?.length && !p.channels.includes(channel)) continue;
      return { ...p, label: dealLabel(p) };
    }
    return null;
  };
}
